import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { createUserSlice, UserSlice } from './user.slice';
import { createSelectors } from '../selectors';
import { BreadcrumbsSlice, createBreadcrumbsSlice } from './breadcrumbs.slice';
import { AuthenticationSlice, createAuthenticationSlice } from './authentication.slice';
import { AccessTokenSlice, createAccessTokenSlice } from './accessToken.slice';
import { RevisionHistorySlice, createRevisionHistorySlice } from './revisionHistory.slice';
import { AlertSlice, createConfigurationListSlice } from './alert.slice';
import { EntityPendingChangesSlice, createEntityPendingChangesSlice } from './EntityPendingChanges.slice';
import { createEntityReviewChangesSlice, EntityReviewChangesSlice } from './EntityReviewChanges.slice';
import { ListSlice, createListSlice } from './list.slice';
import { RevisionHistoryByIdSlice, createRevisionHistoryByIdSlice } from './revisionHistoryById.slice';
import { createDownloadCsvFileByIdSlice, DownloadCsvFileByIdSlice } from './downloadCsvFileById.slice';
import { createDownloadCsvStreamSlice, DownloadCsvStreamSlice } from './downloadCsvStream.slice';
import { decrypt, encrypt } from '../utils';
import { ConfigurationSlice, createConfigurationSlice } from './configuration.slice';
import { createPollingSlice, PollingSlice } from './polling.slice';
import { SidePanelSlice, createSidePanelSlice } from './sidePanel.slice';
import { createGenericPollerSlice, GenericPollerSlice } from './genericPoller.slice';
import { createInProgressIdsSlice, InProgressIdsSlice } from './inProgressIds.slice';
import { createBatchPollingSlice, BatchPollingSlice } from './createBatchPolling.slice';

const useAppStoreBase = create<
    UserSlice &
        BreadcrumbsSlice &
        AuthenticationSlice &
        AccessTokenSlice &
        RevisionHistorySlice &
        AlertSlice &
        EntityPendingChangesSlice &
        ListSlice &
        RevisionHistoryByIdSlice &
        DownloadCsvFileByIdSlice &
        DownloadCsvStreamSlice &
        EntityReviewChangesSlice &
        ConfigurationSlice &
        PollingSlice &
        SidePanelSlice &
        GenericPollerSlice &
        InProgressIdsSlice &
        BatchPollingSlice
>()(
    persist(
        (...state) => ({
            ...createUserSlice(...state),
            ...createBreadcrumbsSlice(...state),
            ...createAuthenticationSlice(...state),
            ...createAccessTokenSlice(...state),
            ...createRevisionHistorySlice(...state),
            ...createConfigurationListSlice(...state),
            ...createEntityPendingChangesSlice(...state),
            ...createEntityReviewChangesSlice(...state),
            ...createListSlice(...state),
            ...createRevisionHistoryByIdSlice(...state),
            ...createDownloadCsvFileByIdSlice(...state),
            ...createDownloadCsvStreamSlice(...state),
            ...createConfigurationSlice(...state),
            ...createPollingSlice(...state),
            ...createSidePanelSlice(...state),
            ...createGenericPollerSlice(...state),
            ...createInProgressIdsSlice(...state),
            ...createBatchPollingSlice(...state)
        }),
        {
            name: 'app-storage',
            storage: createJSONStorage(() => sessionStorage, {
                replacer: (key, value) => encrypt(key, value),
                reviver: (key, value) => decrypt(key, value as string | CryptoJS.lib.CipherParams)
            }),
            partialize: (state) => ({
                currentListId: state.currentListId,
                revisionHistoryById: state.revisionHistoryById,
                isFourEyeApproval: state.isFourEyeApproval,
                externalListAllListCount: state.externalListAllListCount
            })
        }
    )
);

export const useAppStore = createSelectors(useAppStoreBase);
